import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { Layout } from './components/Layout';
import RequireAuth from './components/RequireAuth';
import './custom.css';

export default class App extends Component {
  static displayName = App.name;

  render() {
    return (
      <Layout>
        <Routes>
          {AppRoutes.map((route, index) => {
            const { element, requiresAuth, ...rest } = route;
            const renderedElement = requiresAuth ? (
              <RequireAuth>{element}</RequireAuth>
            ) : (
              element
            );
            return <Route key={index} {...rest} element={renderedElement} />;
          })}
        </Routes>
      </Layout>
    );
  }
}
